import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * Used to extend Directives with subscription functionalities
 *
 * For more flexebility use withSubscription mixin
 */

// we need to use an angular annotation here to satisfy the angular compiler
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class SubscriptionComponent implements OnDestroy {
    protected sub = new Subscription();

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}

export type Constructor<T> = new (...args: any[]) => T;
